import { api } from './client'

export interface AdminUser {
  id: string
  username: string
  email: string | null
  is_sudo: boolean
  is_primary_sudo: boolean
  storage_tier: string
  storage_used: number
  created_at: string
}

export interface AdminConfig {
  [key: string]: string
}

export interface QuotaUpdate {
  rando_mb?: number
  bud_mb?: number
  bff_mb?: number
  default_tier?: string
}

export function listAdminUsers(): Promise<AdminUser[]> {
  return api.get<AdminUser[]>('/admin/users')
}

export function setUserTier(username: string, tier: string): Promise<void> {
  return api.put<void>(`/admin/users/${username}/tier?tier=${encodeURIComponent(tier)}`, undefined)
}

export function grantSudo(username: string): Promise<void> {
  return api.post<void>('/admin/sudo', { username })
}

export function revokeSudo(username: string): Promise<void> {
  return api.delete(`/admin/sudo/${username}`)
}

export function getAdminConfig(): Promise<AdminConfig> {
  return api.get<AdminConfig>('/admin/config')
}

export function updateAdminConfig(body: QuotaUpdate): Promise<AdminConfig> {
  return api.put<AdminConfig>('/admin/config', body)
}
